<template>
  <div>
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 700px"
    >
      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer"/>
      <!-- Item 4 task 2.3: the report this customer's enquiries live in, already filtered to
           them. Shown only when a drill target is configured on the Customer column. -->
      <Button
        v-if="customerDrillTarget"
        style="float: left; margin-left: 8px;"
        label="Enquiries for this customer"
        icon="pi pi-list"
        @click="viewCustomerEnquiries"
      />
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />
      <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      />
    </OverlayPanel>

    <DataTable
      :key="tableKey"
      :value="data"
      :frozenValue="[sumsRow]"
      :expandedRows="expandedRows"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      dataKey="oppId"
      ref="reportTableRef"
      :rowHover="true"
      :selection.sync="selectedRows"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{last} of {totalRecords} Reports"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @row-expand="onRowExpand"
      @row-collapse="onRowCollapse"   
      @column-resize-end="colsResized"
      :reorderableColumns="false" 
      @column-reorder="colReordered"
      @page="onPage($event)"
      :lazy="true"
      :totalRecords="totalRecords"
      @sort="onSort($event)"
      :sortField="defaultSortField"
      :sortOrder="defaultSortOrder"
      :first="defaultFirstPage"
      :rows="defaultRows"
      @row-click="rowClicked($event)" 
      contextMenu
      :contextMenuSelection.sync="selectedRow"
      @row-contextmenu="onRowContextMenu"
      :scrollable="true"
      scrollHeight='60vh'
      scrollDirection="both"
      frozenWidth="0px"
    >
      <!-- :scrollHeight="calculateHeight()"
      style="width: 100%" -->
      <template #empty> No reports found. </template>
      <template #loading> Loading reports data. Please wait. </template>
      <div
        :key="columnsKey"
      >
        <!-- <Column selectionMode="multiple" headerStyle="width: 3em"></Column> -->
        <Column 
          header="Actions"
          headerStyle="width: 0px; height: 30px; padding: 10px 0px;"
          :frozen="true"
        >
          <template #body="slotProps">
            <div  
              style="height: 40px; padding: 10px 0px; display: flex; align-items: center;"
            >
            </div>
          </template>
        </Column>

        <!-- Uncomment the follwing commented code to make Outstanding Orders-Details Report expandable such that it can show the history of quotes  -->

        <!-- <Column :expander="true" headerStyle="width: 3rem" class="expandable-row" v-if="reportType === 'Outstanding Orders-Details'"/> -->
        <Column 
          v-for="(col, index) in colSelectedFieldsForTable" 
          :key="index"
          :field="col.colField" 
          :header="col.colName" 
          :sortable="col.canSort"
          :headerStyle="'width: ' + col.colWidth + 'px; height: 41px; border-width: 0px;'"
          bodyStyle="border-right-width: 0px;; border-left-width: 0px;"
        >
          <template #body="slotProps">
            <div
              style="height: 40px; padding: 10px 0px;"
              @click="openOP(slotProps.data, col, $event)"
              :class="getStyle1(slotProps.data, col)"
            >
              <span>{{ getToShow(slotProps.data, col) }}</span>
            </div>
          </template>
        </Column>
      </div>
      
      <!-- Uncomment the follwing commented code to make Outstanding Orders-Details Report expandable such that it can show the history of quotes  -->
      <!-- <template #expansion="slotProps">
        <div class="orders-subtable" style="background-color: #44a4f4; color: white; padding: 5px;">
          <h5>History Records for "{{ slotProps.data.oppDescription }}"</h5>
          <DataTable
            :value="recentHistoryOrderRecords"
            :loading="historyOrderRecordsLoading"
            class="p-datatable-sm"
            dataKey="oppId"
            :selection.sync="selectedHistoryRecords"
            :scrollable="true"
            scrollHeight="400px"
            :style="{ 'width': '100%' }"
          >
            <Column
          field="date"
          header="Date"
          headerStyle="width: 3em"
          :sortable="true"
        >
          <template #body="slotProps">
            <div>
              {{ slotProps.data.dateCreated }}
            </div>
          </template>
            </Column>
            <Column
              field="user"
              header="User"
              headerStyle="width: 3em"
              :sortable="true"
            >
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.user && slotProps.data.user.fullName ? slotProps.data.user.fullName : '' }}
                </div>
              </template>
            </Column>
            <Column
              field="details"
              header="Details"
              headerStyle="width: 8em"
              :sortable="true"
            >
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.recDetails }}
                </div>
              </template>
            </Column>
            <Column
              field="extraInfo"
              header="More Info"
              headerStyle="width: 8em"
              :sortable="true"
            >
              <template #body="slotProps">
                <div>
                  {{ slotProps.data.extraInfo }}
                </div>
              </template>
            </Column>
          </DataTable>
        </div>
      </template> -->



      <!-- <template #footer>
          In total there are {{ reports.length }} rows.
      </template> -->
    </DataTable>

  </div>
</template>
<script>
import { formatCurrency } from '@/utils/money'
import { drillTarget } from '@/mbp/dashboard/dashboardDrill'
import ReportsService from "@/service/ReportsService"
import CustomerService from "@/service/CustomerService"
import AttachmentService from "@/service/AttachmentService"

import HistoryTable from '../customer/customerHistoryTable'

export default {
  components: {
    HistoryTable
  },
  props: [
    "reports",
    "reportType", 
    "loading", 
    "colSelectedFieldsForTable", 
    "dbViewFields", 
    'totalRecords',
    'rows',
    'currentPage',
    'reloadTable',
    'reportIndexForStore'
  ],
  data: () => ({
    reportsService: new ReportsService(),
    customerService: new CustomerService(),
    attachmentService: new AttachmentService(),

    selectedRows: [],
    selectedRow: null,
    
    report: {},
    tempCustomer: {},
    // Where the Customer panel's "Enquiries for this customer" button goes, for the customer
    // whose cell was clicked. Null when no drill target is configured on that column.
    customerDrillTarget: null,
    
    previousPage: null,
    scheduleDialog: false,
    reloadScheduleDialog: 0,
    tableKey1: 0,
    columnsKey1: 0,
    defaultSortField: '',
    defaultSortOrder: 0,
    defaultFirstPage: 1,
    defaultRows: 25,
    sendingRequest: false,

    customerHistory: [],
    customerHistoryLoading: false,

    expandedRows: [],
    recentHistoryOrderRecords: [],
    historyOrderRecordsLoading: false,
    selectedHistoryRecords: null,

    data: [],
    sumsRow: {}
  }),
  created() {
    
    
    this.setupComponent()
  },
  mounted() {

    // setTimeout(() => {
    //   this.setBordersOfLastRow()
    // }, 100)
    
  },
  computed: {
    // Resolving a target report's id to the name the reports route matches on.
    allReports() {
      return (this.$store && this.$store.getters['reports/getAllReports']) || []
    },
    tableKey: {
      set(val) {
        this.tableKey1++
      }, 
      get() {
        return 'tableKey-' + this.tableKey1.toString()
      }
    },
    columnsKey: {
      set(val) {
        this.columnsKey1++
      }, 
      get() {
        return 'columnKey-' + this.columnsKey1.toString()
      }
    }
  },
  watch: {
    rows(val) {
      this.defaultRows = val + 1
    },
    currentPage(val) {
      this.defaultFirstPage = (val - 1) * this.defaultRows
    },
    reloadTable(val) {
      
      this.setupComponent()

      this.tableKey++
    },
    reports(val) {
      
      this.doSumAndCount()
      setTimeout(() => {
        this.setWidthOfColumns()
      }, 100)
      // this.setWidthOfColumns()

      this.columnsKey++
    },
    colSelectedFieldsForTable(val) {
      
      
      this.doSumAndCount()
      this.columnsKey++
    }
  },
  methods: {
    onRowCollapse(event) {
      this.expandedRows = this.expandedRows.filter(
        (p) => p.oppId !== event.data.oppId
      );
      
      this.recentHistoryOrderRecords = []
    },
    onRowExpand(event) {
      setTimeout(() => {
        this.removeActionsExpand()
      }, 50)
      this.recentHistoryOrderRecords = []

      this.expandedRows = this.data.filter(
        (p) => p.oppId === event.data.oppId
      );

      this.historyOrderRecordsLoading = true
      this.reportsService.getEnquiryRecHistActivities(event.data.oppId)
        .then(data => {
          this.recentHistoryOrderRecords = data
          this.historyOrderRecordsLoading = false
          setTimeout(() => {
            this.setSplitButtonLocations()
            this.removeActionsExpand()
          }, 50)
        })
        .catch(err => {
          this.historyOrderRecordsLoading = false
        })
    },
    removeActionsExpand() {
      let a = document.getElementsByClassName('orders-subtable')
      if (a[0])
        a[0].style.backgroundColor = 'white'

      let b = document.getElementsByClassName('p-checkbox p-component')
      let c = Math.floor(b.length / 2)
      
      for (let i = 0; i < c; i++) {
        if (b[i]) {
          b[i].style.display = 'none'
        }
      }
    },
    setSplitButtonLocations() {
      // getElementsByClassName gives an HTMLCollection, which has no forEach (it threw on every list load).
      let a = Array.from(document.getElementsByClassName('splitButtonColumn'))
      if (a) {
        a.forEach(div => {
          // 
          div.style.top = (div.parentElement.offsetTop + 10).toString() + 'px'
          div.style.left = (div.parentElement.offsetLeft + 10).toString() + 'px'
        })
      }
    },
    setWidthOfColumns() {
      let a = document.getElementsByClassName('p-datatable-tbody')

      if (a.length >= 2) {
        let copy = a[a.length - 2], paste = a[a.length - 1]

        if (
          copy 
          && copy.children 
          && copy.children.length 
          && copy.children[0]
          && copy.children[0].children
          && copy.children[0].children.length
          && paste 
          && paste.children
          && paste.children.length
          && paste.children[0]
          && paste.children[0].children
          && paste.children[0].children.length
          && copy.children[0].children.length === paste.children[0].children.length
        ) {

          for (let i = 0; i < copy.children[0].children.length; i++) {
            let b = copy.children[0].children[i].getBoundingClientRect()

            if (b && b.width) {
              paste.children[0].children[i].style.width = b.width.toString() + 'px'
            }

          }
        }
      }
    },
    setBordersOfLastRow() {
      // 
      let a = document.getElementsByTagName('tr')
      // 
      if (a && a.length) {
        a[a.length - 1].children.forEach((b, index) => {
          if (this.colSelectedFieldsForTable[index].applySum) {
            // b.style.borderWidth = 5 + 'px'
            b.children[0].children[0].style.color ='white'
            b.children[0].children[0].style.padding ='5px'
            b.children[0].children[0].style.fontWeight ='bold'
            
            if (
              this.$store.getters['getActiveThemeColor']
            ) {
              // b.style.borderColor = this.$store.getters['getActiveThemeColor']
              b.children[0].children[0].style.backgroundColor = this.$store.getters['getActiveThemeColor']
            } else {
              // b.style.borderColor = 'black'
              b.children[0].children[0].style.backgroundColor = 'black'
            }
          }
        })
      }
    },
    doSumAndCount() {
      // 

      for (let i = 0; i < this.reports.length; i++) {
        for (let j = 0; j < this.colSelectedFieldsForTable.length; j++) {
          if (i === 0) {
            if (this.colSelectedFieldsForTable[j].applySum) {
              this.sumsRow[this.colSelectedFieldsForTable[j].colField] = 0
            } else {
              this.sumsRow[this.colSelectedFieldsForTable[j].colField] = null
            }
          }

          if (j === 0) {
            this.sumsRow[this.colSelectedFieldsForTable[j].colField] = 'Totals'
          }

          if (
            typeof this.sumsRow[this.colSelectedFieldsForTable[j].colField] === 'number'
          ) {
            this.sumsRow[this.colSelectedFieldsForTable[j].colField] += this.reports[i][this.colSelectedFieldsForTable[j].colField]
            
          }

        }
      }

      this.data = [
        ...this.reports,
        this.sumsRow
      ]

      // Uncomment the follwing commented code to make Outstanding Orders-Details Report expandable such that it can show the history of quotes

      // if(this.reportType === "Outstanding Orders-Details")
      // {
      //   this.$nextTick(() => {
      //     // removing Expandable button(icon) for first row with totals
      //     this.$refs.reportTableRef.$el.children[1].children[1].children[0].children[0].children[0].children[2].children[0].children[0].children[0].style.display = 'none'


      //     // removing Expandable button(icon) for last row with totals
      //     var children = this.$refs.reportTableRef.$el.children[1].children[1].children[1].children[0].children[1].children

      //     for(var i=0; i< children.length; i++)
      //     {
      //       var tr = children[i];
      //       if(tr.children[1].children[0].children[0].innerText == "Totals") tr.children[0].children[0].style.display = 'none'
      //     }
      //   });
      // }

    },
    onRowContextMenu(event) {
      // this.$refs.cm.show(event.originalEvent);
    },
    rowClicked(event) {
      // 
    },
    setupComponent() {
      

      this.doSumAndCount()

      
      
      if (this.$store.getters['reports/getSortField'][this.reportIndexForStore]) {
        this.defaultSortField = this.$store.getters['reports/getSortField'][this.reportIndexForStore]
        this.defaultSortOrder = this.$store.getters['reports/getSortOrder'][this.reportIndexForStore]
        
      } else {
        this.defaultSortField = ''
        this.defaultSortOrder = 0
      }

      this.defaultRows = this.$store.getters['reports/getRows'][this.reportIndexForStore] + 1
      this.defaultFirstPage = (this.$store.getters['reports/getPage'][this.reportIndexForStore] - 1) * this.defaultRows

      setTimeout(() => {
        this.setWidthOfColumns()
      }, 100)
    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    // What a cell leads to, from the column's own configuration (db_report_columns:
    // drill_report_id, drill_carry_field, drill_value_field). Null when the column carries no
    // target, the row has no value to carry, or the target report is not one this user has.
    cellDrillTarget(col, data) {
      if (!col || !col.drillReportId || !col.drillCarryField || !col.drillValueField) return null
      const value = data ? data[col.drillValueField] : null
      if (value === null || value === undefined || String(value).trim() === '') return null

      return drillTarget(
        { reportId: col.drillReportId, drill: { [col.drillCarryField]: String(value) } },
        this.allReports
      )
    },
    viewCustomerEnquiries() {
      if (this.customerDrillTarget) this.$router.push(this.customerDrillTarget)
    },
    openOP(data, col, event) {
      const target = this.cellDrillTarget(col, data)

      // The Customer cell keeps the history panel it has always opened; its drill is offered as
      // a button inside that panel instead of replacing it (Mohammed, 2026-09-17).
      if (target && col.colField !== 'custName') {
        this.$router.push(target)
        return
      }
      this.customerDrillTarget = col.colField === 'custName' ? target : null

      if (data && data.customerId && col.colField === 'custName') {
        this.tempCustomer = {
          custName: data.custName,
          customerId: data.customerId
        }
        this.customerHistory = []
        this.customerHistoryLoading = true
        this.customerService
          .getCustomerHistory(data.customerId)
          .then(data => {
            if (data.length > 20) {
              this.customerHistory = data.slice(0, 20);
            } else {
              this.customerHistory = data
            }
            this.customerHistoryLoading = false
          })
          .catch(err => {
            this.customerHistoryLoading = false
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
        this.toggle(event);
      }
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "/customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "/customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    colReordered(event) {
      
    },
    colsResized(event) {
      // 
      
      if (
        event.element && 
        event.element.clientWidth &&
        event.element.textContent
      ) {
        let e = event.element.clientWidth, b = this.colSelectedFieldsForTable.findIndex(a => a.colName === event.element.outerText)
        // 
        
        if (b > -1) {
          let c = [...this.colSelectedFieldsForTable]
          c[b].colWidth = e

          this.$emit('colsUpdated', c)
        }
      }
    },
    onSort(event) {
      // C2: one sort, for the column whose colField is the one clicked (not every column sharing its last segment)
      const col = (this.colSelectedFieldsForTable || []).find(c => c && c.colField === event.sortField)
      if (col) {
        this.$emit('sortChange', {
          sortField: event.sortField,
          sortFieldId: col.id,
          sortOrder: event.sortOrder
        })
      }
    },
    onPage(event) {
      
      if (!(this.previousPage && event.page === this.previousPage.page && event.rows === this.previousPage.rows && event.pageCount === this.previousPage.totalpages)) {
        this.previousPage = {
          page: event.page + 1,
          rows: event.rows - 1,
          totalPages: event.pageCount
        }
        this.$emit('lazyNext', this.previousPage)
      }
    },
    getStyle1(data, col) {

      if (
        col.colField === 'quoteVer' ||
        col.colField === 'custName' ||
        this.cellDrillTarget(col, data)
      ) {
        return 'under_lined'
      }
      if(data.sQuoteNo === 'Totals' && (col.colField === 'quoteQty' || col.colField === 'productValue'))
      {
        return 'brown-background'
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let b = data[col.colField]

      // 

      if (
        b !== null 
        && b !== undefined
      ) {

        if (
          col.colType === "Currency"
        ) {
          try {
              
            return formatCurrency(b)

          } catch (e) {
            return b
          }
        } else if (col.colType === 'Number') {
          
          try {
            let c = b.toString().split('.')
            // 

            if (c[0]) {
              let d = c[0].split(',')
              if (d.length < 2) {
                c[0] = this.numberWithCommas(c[0])
              }
            }

            return `${c[0]}`

          } catch (e) {
            return b
          }

        } else {
          return b
        }
        
      } else {
        return ''
      }
    },
    calculateHeight() {
      return (window.innerHeight - 330).toString() + 'px'
    }
  }
};
</script>

<style scoped lang="scss">

.brown-background {
  color: white;
  font-weight: bold;
  background-color: #795548;
  text-align: center;
  padding: 5px 5px!important;
  height: 30px!important;
  width: fit-content;
}
</style>
